import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useClienteController from "../controllers/ClienteController";
import { useContext, useEffect, useState } from "react";
import { ClienteContext } from "../contexts/ClienteContext";
import MaskService from "../../../../utils/mask/maskService";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import Fieldset from "../../../../components/basics/Fieldset";

export default function ModalClienteContato({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
}) {
  const {
    //Dados Gerais
    generalCustomerId,

    contacts,
    setContacts,

    loadingInputs,
    listUf,
    listCounty,

    expanded,
  } = useContext(ClienteContext);
  const { handleChangeCep, handleChangeUf } = useClienteController();

  const [contactCpf, setContactCpf] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactRamal, setContactRamal] = useState("");
  const [contactTelephone, setContactTelephone] = useState("");
  const [contactWppActive, setContactWppActive] = useState(0);
  const [contactDepartament, setContactDepartament] = useState("");
  const [contactCep, setContactCep] = useState("");
  const [contactAddress, setContactAddress] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [contactDistrict, setContactDistrict] = useState("");
  const [contactUf, setContactUf] = useState(null);
  const [contactCounty, setContactCounty] = useState("");
  const [contactSendNfe, setContactSendNfe] = useState(false);
  const [contactMain, setContactMain] = useState(0);
  const [contactComplement, setContactComplement] = useState("");
  const [contactSendEstimate, setContactSendEstimate] = useState(false);
  const [contactSendFinancial, setContactSendFinancial] = useState(false);
  const [errorsModal, setErrorsModal] = useState({});

  useEffect(() => {
    if (!rowEdit || !rowEdit.data) return;

    const { data } = rowEdit;

    setContactCpf(MaskService.toMask("cpf", data.cpf || ""));
    setContactName(data.nomecontato || "");
    setContactEmail(data.email || "");
    setContactTelephone(MaskService.toMask("cel-phone", data.celular || ""));
    setContactWppActive(data.whatsapp_ativo === 1);
    setContactRamal(data.telefoneramal || "");
    setContactDepartament(data.depto || "");
    setContactCep(MaskService.toMask("cep", data.cep || ""));
    setContactAddress(data.endereco || "");
    setContactNumber(data.numero || "");
    setContactDistrict(data.bairro || "");
    setContactSendNfe(data.email_utilizarnfe === "S");
    setContactMain(data.principal.toString() === "1");
    setContactComplement(data.complemento || "");
    setContactSendEstimate(data.email_utilizarorcamentovenda === "S");
    setContactSendFinancial(data.email_utilizarfinanceiro === "S");
  }, [rowEdit]);

  useEffect(() => {
    if (!rowEdit || !rowEdit.data || !rowEdit.data.id_estado) return;

    setContactUf(
      listUf.find((option) => option.id === rowEdit.data.id_estado) || null
    );
  }, [rowEdit, listUf]);

  useEffect(() => {
    if (!rowEdit || !rowEdit.data || !rowEdit.data.municipio_codigo) return;
    setContactCounty(
      listCounty.find(
        (option) => option.codigo === rowEdit.data.municipio_codigo
      ) || null
    );
  }, [listCounty, rowEdit]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  const handleAdd = () => {
    const resultValidation = validNotNull([
      { key: "contactName", value: contactName },
    ]);

    if (contactCpf && !MaskService.isValid("cpf", contactCpf)) {
      resultValidation.error = true;
      resultValidation.errorsValidation.contactCpf = "CPF inválido";
    }

    if (contactCep && !MaskService.isValid("cep", contactCep)) {
      resultValidation.error = true;
      resultValidation.errorsValidation.contactCep = "CEP inválido";
    }

    if (
      contactTelephone &&
      !MaskService.isValid("cel-phone", contactTelephone)
    ) {
      resultValidation.error = true;
      resultValidation.errorsValidation.contactTelephone = "Telefone inválido";
    }

    setErrorsModal(resultValidation.errorsValidation);
    if (resultValidation.error)
      return notify("Verifique se os campos estão preenchidos corretamente.");

    let copyContactAddress = [...contacts];

    const body = {
      cpf: contactCpf,
      nomecontato: contactName,
      email: contactEmail,
      telefoneramal: contactRamal,
      depto: contactDepartament,
      cep: contactCep.replace(/[^0-9]+/g, ""),
      endereco: contactAddress,
      numero: contactNumber,
      cidade: contactCounty ? contactCounty.municipio : null,
      municipio_codigo: contactCounty ? contactCounty.codigo : null,
      id_estado: contactUf ? contactUf.id : null,
      bairro: contactDistrict,
      celular: contactTelephone.replace(/[^0-9]+/g, ""),
      whatsapp_ativo: contactWppActive ? 1 : 0,
      email_utilizarnfe: contactSendNfe ? "S" : "N",
      principal: contactMain ? "1" : "0",
      complemento: contactComplement,
      email_utilizarorcamentovenda: contactSendEstimate ? "S" : "N",
      email_utilizarfinanceiro: contactSendFinancial ? "S" : "N",
    };

    if (contactMain) {
      copyContactAddress = copyContactAddress.map((item) => ({
        ...item,
        principal: 0,
      }));
    }

    if (generalCustomerId) body.idclientes = generalCustomerId;

    if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
      body.id = rowEdit.data.id || null;

      if (rowEdit.index !== -1) {
        const copy = [...copyContactAddress];
        copy[rowEdit.index] = body;
        setContacts(copy);
      }
    } else {
      setContacts([...copyContactAddress, body]);
      notify("Contato adicionado com sucesso!", true, "success");

      expanded.contacts = true;
    }

    setOpen(false);
    setRowEdit(null);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container>
            <Grid item>
              Cadastro de Contato
              {rowEdit && rowEdit.id ? `: (${rowEdit.id})` : ""}
            </Grid>
            <Grid item style={{ marginLeft: "10px" }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={contactMain}
                    onChange={() => setContactMain((current) => !current)}
                    color="primary"
                  />
                }
                label="Principal"
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.contactCpf || false}
                helperText={errorsModal.contactCpf || ""}
                label="CPF"
                value={contactCpf}
                setValue={setContactCpf}
                mask="cpf"
              />
            </Grid>

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.contactName || false}
                helperText={errorsModal.contactName || ""}
                label="Nome*"
                maxLength={60}
                value={contactName}
                setValue={setContactName}
              />
            </Grid>

            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                label="Departamento"
                maxLength={15}
                value={contactDepartament}
                setValue={setContactDepartament}
              />
            </Grid>

            <Grid item lg={2} md={2} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.contactTelephone ? true : false}
                helperText={errorsModal.contactTelephone || ""}
                label="Celular"
                maxLength={50}
                value={contactTelephone}
                setValue={setContactTelephone}
                mask="cel-phone"
              />
              <Grid item>
                <FormControlLabel
                  control={
                    <Switch
                      checked={contactWppActive}
                      onChange={() =>
                        setContactWppActive((current) => !current)
                      }
                      color="primary"
                    />
                  }
                  label="Whatsapp"
                />
              </Grid>
            </Grid>

            <Grid item lg={2} md={3} sm={6} xs={12}>
              <TextFieldErp
                label="Ramal"
                maxLength={20}
                value={contactRamal}
                setValue={setContactRamal}
              />
            </Grid>

            <Grid item lg={2} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.contactCep ? true : false}
                helperText={errorsModal.contactCep || ""}
                label="CEP"
                value={contactCep}
                onChange={(e) =>
                  handleChangeCep(e, null, {
                    setCep: setContactCep,
                    setAddress: (value) =>
                      setContactAddress((value || "").substring(0, 60)),
                    setComplement: () => {},
                    setCounty: setContactCounty,
                    setUf: setContactUf,
                    setDistrict: (value) =>
                      setContactDistrict((value || "").substring(0, 60)),
                  })
                }
                mask="cep"
                InputProps={{
                  endAdornment: <SearchIcon onClick={() => {}} />,
                }}
              />
            </Grid>

            <Grid item lg={5} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Endereço"
                maxLength={60}
                value={contactAddress}
                setValue={setContactAddress}
              />
            </Grid>

            <Grid item lg={2} md={2} sm={6} xs={12}>
              <TextFieldErp
                label="Número"
                maxLength={50}
                value={contactNumber}
                setValue={setContactNumber}
              />
            </Grid>

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFieldErp
                label="Complemento"
                maxLength={60}
                value={contactComplement}
                setValue={setContactComplement}
              />
            </Grid>

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFieldErp
                label="Bairro"
                maxLength={60}
                value={contactDistrict}
                setValue={setContactDistrict}
              />
            </Grid>

            <Grid item lg={1} md={2} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs.listUf || false}
                label="Estado"
                value={contactUf}
                onChange={(e) =>
                  handleChangeUf(e, setContactUf, setContactCounty)
                }
                optionsList={listUf}
                descriptionField="estado"
              />
            </Grid>

            <Grid item lg={2} md={4} sm={12} xs={12}>
              <SelectErp
                loading={loadingInputs.listCounty || false}
                label="Municipio"
                value={contactCounty}
                setValue={setContactCounty}
                optionsList={
                  contactUf
                    ? listCounty.filter(
                        (opt) => opt.estado_codigo === contactUf.codibge
                      )
                    : []
                }
                descriptionField="municipio"
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Fieldset
                titulo="Envio de Email"
                bgcolor="secondary"
                textcolor="black"
              >
                <Grid container spacing={2}>
                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <TextFieldErp
                      label="E-mail"
                      maxLength={60}
                      value={contactEmail}
                      setValue={setContactEmail}
                    />
                  </Grid>
                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <FormControlLabel
                      value="end"
                      control={
                        <Switch
                          checked={contactSendNfe}
                          onChange={() =>
                            setContactSendNfe((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="NF-e"
                      labelPlacement="end"
                    />
                  </Grid>

                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <FormControlLabel
                      value="end"
                      control={
                        <Switch
                          checked={contactSendFinancial}
                          onChange={() =>
                            setContactSendFinancial((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="Financeiro"
                      labelPlacement="end"
                    />
                  </Grid>

                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <FormControlLabel
                      value="end"
                      control={
                        <Switch
                          checked={contactSendEstimate}
                          onChange={() =>
                            setContactSendEstimate((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="Orçamento/Venda"
                      labelPlacement="end"
                    />
                  </Grid>
                </Grid>
              </Fieldset>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleAdd} />
        </DialogActions>
      </Dialog>
    </>
  );
}
